export default __webpack_public_path__ + "2014 Infrared-matchgate.pdf";